<template>
  <div class="card-office transition">
    <div class="card-office__content">
      <figure class="card-office__image">
        <img
          v-if="data && data.img"
          class="img-fluid"
          ref="image"
          :src="data.img"
          :alt="data.name"
          @error="loadPlaceholderImage"
        />
      </figure>
      <div class="card-office__info">
        <h3 class="title weight-bolder transition">
          {{ (data && data.name) || '--' }}
        </h3>
        <p class="text my-0 weight-regular">
          {{ (data && data.address) || '--' }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CardOffice',
  props: {
    data: {
      type: Object,
      default: null,
    },
  },
  methods: {
    loadPlaceholderImage() {
      this.$refs.image.src = require('./../assets/images/office.png');
    },
  },
};
</script>

<style></style>
